/*
 Клик, которым пользователь закрывает переименование, не должен заодно выбирать элемент.
 Строка, чья правка закончилась, оставляет отметку, а строка, поймавшая следующий клик,
 её забирает и клик не обрабатывает. Состояние общее, потому что отметку ставит один
 экземпляр BaseListElementLite, а забирает другой.
*/

// Запас на путь mousedown -> blur -> click. Дольше держать нельзя: отметку заберёт
// уже осмысленный клик пользователя.
const RENAME_HANDOFF_MS = 400;
let renameEndedAt = 0;

export function markRenameEnded() {
  renameEndedAt = Date.now();
}

export function consumeRenameHandoff(): boolean {
  if (!renameEndedAt) return false;
  const fresh = Date.now() - renameEndedAt < RENAME_HANDOFF_MS;
  renameEndedAt = 0;
  return fresh;
}
